<template>
  <transition :name="$style.overlay">
    <div v-if="isActive" :class="$style.overlay" />
  </transition>

  <transition :name="$style.drawer">
    <div v-if="isActive" :class="$style.drawer">
      <app-header
        icon-left="x"
        alternative
        @click-icon-left="isActive = false"
        @click-icon-right="navigateTo('/m')"
      />

      <sidebar-primary v-scroll-lock :class="$style.sidebar" reduced />
    </div>
  </transition>
</template>

<script lang="ts" setup>
import AppHeader from '~/components/layout/app/header/index.vue'
import SidebarPrimary from './index.vue'

const isActive = defineModel<boolean>({ required: true })

const route = useRoute()

watch(
  () => route.fullPath,
  () => {
    isActive.value = false
  }
)
</script>

<style lang="scss" module>
.overlay {
  position: fixed;
  inset: 0;
  z-index: calc(var(--layout-app-sidebar-primary-drawer-z-index) - 1);
  backdrop-filter: blur(2.4em);
  background: color-get(--root-rgb-bg-dark, 0.3);

  &:global(-enter-active),
  &:global(-leave-active) {
    transition: opacity 0.3s;
  }

  &:global(-enter-from),
  &:global(-leave-to) {
    opacity: 0;
  }
}

.drawer {
  position: fixed;
  inset: 0;
  z-index: var(--layout-app-sidebar-primary-drawer-z-index);
  background: color-get(--root-rgb-bg-special-1);
  display: flex;
  flex-direction: column;

  &:global(-enter-active),
  &:global(-leave-active) {
    transition: transform 0.4s;
  }

  &:global(-enter-from),
  &:global(-leave-to) {
    transform: translate3d(-100%, 0, 0);
  }
}

.sidebar {
  margin-top: 2em;
  flex: 1 1 0;
}
</style>
